import { MDSComboboxItem, ComboboxState, ComboboxAction } from "./combobox.types";

export function comboboxReducer<T extends MDSComboboxItem>(
  state: ComboboxState<T>,
  action: ComboboxAction<T>
): ComboboxState<T> {
  switch (action.type) {
    case "QUERY_CHANGED":
      return {
        ...state,
        query: action.payload,
      };

    case "SEARCH_STARTED":
      return {
        ...state,
        isOpen: false,
        isLoading: false,
        hasSearched: false,
        data: [] as T[],
      };

    case "SEARCH_COMPLETED":
      return {
        ...state,
        data: action.payload,
        hasSearched: true,
        isLoading: false,
        isOpen: true,
      };

    case "SEARCH_FAILED":
      return {
        ...state,
        hasSearched: true,
        isLoading: false,
      };

    case "LOADING_STARTED":
      return {
        ...state,
        isLoading: true,
        isOpen: true,
      };

    case "LOADING_STOPPED":
      return {
        ...state,
        isLoading: false,
      };

    case "POPOVER_OPENED":
      return {
        ...state,
        isOpen: true,
      };

    case "POPOVER_CLOSED":
      return {
        ...state,
        isOpen: false,
      };

    case "EMPTY_STATE_CHANGED":
      return {
        ...state,
        isEmpty: action.payload,
      };

    case "RESET":
      return {
        ...state,
        isOpen: false,
        isLoading: false,
        hasSearched: false,
        data: [] as T[],
        query: "",
      };

    default:
      return state;
  }
}
